import { NoticeProps, components } from "react-select";
import { TAssertionSelectDefaultOption } from "../../../AssertionSentences.types";
import "./NoOptionsMessage.styles.scss";

type NoOptionsMessageProps<
  Option extends TAssertionSelectDefaultOption = TAssertionSelectDefaultOption
> = {
  noOptionsText: string;
} & NoticeProps<Option, false>;

export const NoOptionsMessage = <
  Option extends TAssertionSelectDefaultOption = TAssertionSelectDefaultOption
>(
  props: NoOptionsMessageProps<Option>
): JSX.Element => {
  const { noOptionsText } = props;

  return (
    <components.NoOptionsMessage
      {...props}
      className="nb-interactive-true-or-false-assertion-select-no-options"
    >
      {noOptionsText ? noOptionsText : props.children}
    </components.NoOptionsMessage>
  );
};
